import MessageHandler from 'message-handler';

require('es6-promise').polyfill();
require('isomorphic-fetch');


export default class FormSwiftAPIClient {
  static getQueryString(params) {
    let queryString = '';
    if (!params) {
      return queryString;
    }

    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (queryString.length === 0) {
        queryString += '?';
      } else {
        queryString += '&';
      }
      queryString += `${key}=${value}`;
    });

    return queryString;
  }

  static logException(error) {
    if (window.logCapturedExceptionToConsole) {
      console.log(`captured exception: ${error}`);
    }

    window.Raven.captureException(error);
  }

  constructor(url) {
    this.fetchRequest = this.fetchRequest.bind(this);
    this.request = this.request.bind(this);
    this.url = url;
  }

  async fetchRequest(path, options = null, asRaw = false) {
    try {
      const response = await fetch(`${this.url}${path}`, options);

      if (asRaw) {
        return response;
      }

      const json = await response.json();
      if (json.status === 'success') {
        return Promise.resolve(json);
      }

      const error = new Error(json.message);
      const normalizedMessage = MessageHandler.normalizeMessage(json.message);
      if (
        !MessageHandler.errors[normalizedMessage] ||
        MessageHandler.errors[normalizedMessage].isCritical
      ) {
        FormSwiftAPIClient.logException(error);
      }

      return Promise.reject(error);
    } catch (error) {
      FormSwiftAPIClient.logException(error);
      return Promise.reject(error);
    }
  }

  async fetchRaw(path, options = null) {
    const rawResponse = await fetch(`${this.url}${path}`, options);
    return rawResponse;
  }

  request(method, path = '', payload = null, asRaw = false) {
    if (method === 'GET') {
      const queryString = FormSwiftAPIClient.getQueryString(payload);
      const fullPath = `${path}${queryString}`;

      return this.fetchRequest(fullPath, null, asRaw);
    }

    const options = {
      method: 'POST',
      body: JSON.stringify(payload),
    };

    return this.fetchRequest(path, options, asRaw);
  }

  saveEditorMode(mode) {
    const { ses: sessionHash, key: sessionID } = window.DocumentSettings;
    const response = this.request(
      'POST',
      `/session/${sessionID}/update`,
      {
        editor_mode: mode,
        session_hash: sessionHash,
        user_id: window.COOKIE.get('userid'),
        user_token: window.COOKIE.get('userToken'),
      },
    );

    return response;
  }
}



// WEBPACK FOOTER //
// ./src-react/FormSwiftAPI/FormSwiftAPIClient.jsx